module.exports = __webpack_public_path__ + "img/587.9e81bb13.jpg";